(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/demo-carousel/assets/javascripts/post-script.js') >= 0) return;  svs.modules.push('/components/onboarding/demo-carousel/assets/javascripts/post-script.js');
"use strict";


const requestFullscreenMount = svs.components.onboarding.core.utils.requestFullscreenMount;
requestFullscreenMount(svs.components.onboarding.demo.CarouselDemoOnboardingFullscreen);

 })(window);